import VideoStyles from "@components/cms/video/video.module.css";
import React, { useEffect, useState } from "react";
import { Box } from "@ui/components/layout/box/Box";
import { IconButton } from "@ui/components/forms/icon-button/IconButton";
import { ECCOIcon } from "@ui/components/media-and-icons/ecco-icon/ECCOIcon";
import ReactPlayer from "react-player";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";

export const ProductVideo = ({ productVideo, isGallery = false }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [buttonIsVisible, setButtonIsVisible] = useState(true);
    const { get } = useMicrocopy();

    const toggleMicrocopy = get(CommonCMS.shared, CommonCMS.slide.togglePlay);

    const handleMouseEnter = () => {
        setButtonIsVisible(true);
    };

    const handleMouseLeave = () => {
        const timer = setTimeout(() => {
            setButtonIsVisible(false);
        }, 2000);
        return () => clearTimeout(timer);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (isPlaying) {
                setButtonIsVisible(false);
            }
        }, 2000);
        return () => clearTimeout(timer);
    }, [isPlaying]);

    return (
        <Box
            onClick={() => {
                setIsPlaying(!isPlaying);
                setButtonIsVisible(true);
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                _hover: {
                    cursor: "pointer",
                },
                height: [isGallery ? "60%" : "100%", "100%"],
                width: isGallery ? ["100%", "50%"] : "100%",
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}
        >
            <ReactPlayer
                className={VideoStyles["react-player"]}
                // This data should come for product
                url={productVideo}
                height="100%"
                width="100%"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    overflow: "hidden",
                }}
                controls={false}
                playing={isPlaying}
                muted={true}
                volume={0}
                loop={true}
                playsinline={true}
                id={"product-video"}
            />

            <IconButton
                // We are removing the native controls, we need to tell to assistive technologies this button controls the video
                aria-controls="product-video"
                h="10.4"
                w="10.4"
                backdropFilter={"blur(50px)"}
                boxShadow={"0px 0px 10px 0px rgba(0, 0, 0, 0.10)"}
                bg="transparent"
                opacity={[buttonIsVisible ? 1 : 0]}
                transition={"opacity 0.05s"}
                colorScheme="transparent"
                aria-pressed={isPlaying}
                aria-label={toggleMicrocopy ?? "Toggle play"}
                icon={isPlaying ? <ECCOIcon name="pause" /> : <ECCOIcon name="play" />}
                color="white"
            />
        </Box>
    );
};
